<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import AnimatedTitle from './AnimatedTitle.svelte'

  export let title
  export let mobile
  export let alt
  export let superWide = false
  export let desktop = null
  export let style = 'zoom'

  let pic, st;

  onMount(() => {
    const tl = gsap.timeline()
    if(style === 'zoom') {
      tl.from(pic, {clipPath: `inset(200px 200px)`, ease: 'power2.out', duration: 1}, 0)
      tl.from(pic.querySelector('img'), {scale: 1.5, opacity: 0, ease: 'power2.out', duration: 1}, 0)
    }

    st = ScrollTrigger.create({
      trigger: pic,
      animation: tl,
      start: 'top 60%',
      toggleActions: 'play play play pause'
    })
  })

  onDestroy(() => {
    st?.kill()
  })

</script>

<div class="animated-image" class:is-super-wide={superWide}>
  {#if superWide}
  <div class="content">
    <div class="title-wrap">
      <AnimatedTitle class="large" style="maskup">{title}</AnimatedTitle>
    </div>
  </div>
  {/if}
  <picture bind:this={pic}>
    {#if desktop}
      <source srcset={desktop} media="(min-width: 768px)" />
    {/if}
    <source srcset={mobile} media="(max-width: 767px)" />
    <img src={mobile} {alt} />
  </picture>
</div>

<style>
  .animated-image {
    position: relative;
  }
  .is-super-wide picture {
    margin-left: var(--gutter-sm);
    margin-right: var(--gutter-sm);
  }
  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: contain;
  }
  picture {
    position: relative;
    display: block;
    overflow: hidden;
    margin-top: 45px;
  }
  @media(min-width: 768px) {
    picture {
      opacity: 0.6;
    }
    .title-wrap {
      position: absolute;
      z-index: 1;
      width: 66%;
      padding: 70px var(--gutter-lg) 0;
    }
    .is-super-wide picture {
      margin-left: 0;
      margin-right: 0;
    }
    .is-super-wide .title-wrap {
      padding-left: 0;
      padding-right: 0;
    }
  }
</style>